import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { addAssetRequest, addAssetRequestStatus } from '../../../redux/asset/asset.action'
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import CommonInputFloatHalf from "../../../components/input/common-input-float-half/commonInputFloafHalf";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { CurrencyLabel } from "../../../utils/CurrencyLabel";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import Modal from 'react-bootstrap/Modal';
import moment from "moment";

const AddAssets = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { addAssetSuccess, addAssetError, addAssetReqStatus } = useSelector(state => state.asset)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [name, setName] = useState('')
    const [selectedCategory, setSelectedCategory] = useState()
    const [details, setDetails] = useState('')
    const [serialNumber, setSerialNumber] = useState('')
    const [purchaseCost, setPurchaseCost] = useState('')
    const [purchaseDate, setPurchaseDate] = useState(new Date())
    const [warrantyExpire, setWarrantyExpire] = useState(new Date())
    const [selectedCurrency, setSelectedCurrency] = useState()
    const [notes, setNotes] = useState('')
    const ASSET_CATEGORIES = [
        { key: 'LAPTOP', value: removeSpecialCharAndChangeToPascal('LAPTOP') },
        { key: 'DESKTOP', value: removeSpecialCharAndChangeToPascal('DESKTOP') },
        { key: 'MOBILE', value: removeSpecialCharAndChangeToPascal('MOBILE') },
        { key: 'IT_ACCESSORIES', value: removeSpecialCharAndChangeToPascal('IT_ACCESSORIES') },
        { key: 'HARDWARE_TOOLS', value: removeSpecialCharAndChangeToPascal('HARDWARE_TOOLS') },
        { key: 'OTHER', value: removeSpecialCharAndChangeToPascal('OTHER') },
    ]
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_ASSET, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (addAssetReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (addAssetReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addAssetError.message)
        }
        if (addAssetReqStatus?.length) {
            dispatch(addAssetRequestStatus(''))
        }
    }, [addAssetSuccess, addAssetError, addAssetReqStatus])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.ADD_ASSET) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_ASSET, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    const handleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Asset name cannot be blank')
        } else if (isEmpty(details)) {
            displayErrorToast('Details cannot be blank')
        } else if (isEmpty(selectedCategory)) {
            displayErrorToast('Asset category not selected')
        } else if (isEmpty(serialNumber)) {
            displayErrorToast('Serial number cannot be blank')
        } else if (isEmpty(selectedCurrency)) {
            displayErrorToast('Currency not selected')
        } else if (isEmpty(purchaseCost)) {
            displayErrorToast('Purchase cost cannot be blank')
        } else if (isEmpty(purchaseDate)) {
            displayErrorToast('Purchase date not selected')
        } else if (isEmpty(warrantyExpire)) {
            displayErrorToast('Warranty expire date not selected')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedBusiness)) {
            displayErrorToast('Business not selected')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedLocation)) {
            displayErrorToast('Business location not selected')
        } else {
            setLoading(true)
            const data = {
                name: name,
                details: details,
                category: selectedCategory.key,
                currencyLabel: selectedCurrency.code,
                currencySymbol: selectedCurrency.symbol,
                currencyRegion: selectedCurrency.region,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                serialNumber: serialNumber,
                purchaseCost: purchaseCost,
                purchaseDate: moment(purchaseDate).utc().format("YYYY-MM-DD hh:mm:ss A"),
                warrantyExpiry: moment(warrantyExpire).utc().format("YYYY-MM-DD hh:mm:ss A")
            }
            if (!isEmpty(notes)) {
                data.notes = notes
            }
            dispatch(addAssetRequest(data))
        }
    }

    const clearFields = () => {
        setName('')
        setSelectedCategory(undefined)
        setDetails('')
        setSerialNumber('')
        setPurchaseCost('')
        setPurchaseDate(new Date())
        setWarrantyExpire(new Date())
        setSelectedCurrency(undefined)
        setNotes('')
        setShowSuccessModal(false)
    }

    const handleAddNewAssetClick = () => {
        setShowSuccessModal(false)
        clearFields()
    }

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };


    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='New Asset' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new asset' />
                    <CommonInputFloatFull
                        type='text'
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Name'
                        value={name}
                    />
                    <CommonInputFloatFull
                        type='text'
                        id='details'
                        onChange={e => setDetails(e.target.value)}
                        placeholder='Details'
                        value={details}
                        multiline={true}
                        rows={3}
                    />
                    <FormFieldLabel label='Select Asset Category' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedCategory}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={ASSET_CATEGORIES}
                        placeholder='Select Category'
                        onChange={e => setSelectedCategory(e)} />
                    <CommonInputFloatFull
                        type='text'
                        id='serialNumber'
                        onChange={e => setSerialNumber(e.target.value)}
                        placeholder='Serial Number'
                        value={serialNumber}
                    />
                    <CommonInputRow>
                        {CurrencyLabel && <Select
                            menuPlacement="auto"
                            className='select-half-width'
                            value={selectedCurrency}
                            getOptionLabel={e => `${e.currency} (${e.symbol})`}
                            getOptionValue={e => e}
                            options={CurrencyLabel}
                            placeholder='Select Currency'
                            onChange={e => {
                                setSelectedCurrency(e)
                            }} />}
                        <CommonInputFloatHalf
                            type='text'
                            id='purchaseCost'
                            onChange={e => setPurchaseCost(e.target.value)}
                            placeholder='Purchase Cost'
                            value={purchaseCost}
                        />
                    </CommonInputRow>
                    <CommonInputRow>
                        <div className="as-date-parent-container">
                            <FormFieldLabel label='Purchase Date' />
                            <DatePicker
                                className="as-date-container"
                                selected={purchaseDate}
                                minDate={new Date()}
                                onChange={(date) => {
                                    setPurchaseDate(date)
                                }}
                                dateFormat="MMMM d, yyyy"
                            />
                        </div>
                        <div className="as-date-parent-container">
                            <FormFieldLabel label='Warranty Expire' />
                            <DatePicker
                                className="as-date-container"
                                selected={warrantyExpire}
                                onChange={(date) => setWarrantyExpire(date)}
                                dateFormat="MMMM d, yyyy"
                                minDate={purchaseDate}
                            />
                        </div>
                    </CommonInputRow>
                    {isLoggedInUserBusiness(user) && <div>
                        <FormFieldLabel label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                        {!isEmpty(selectedBusiness) && <div>
                            <FormFieldLabel label='Select Business Location' />
                            {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                                className='select-full-width-no-border'
                                value={selectedLocation}
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e}
                                options={businessLocationListSuccess.data}
                                placeholder='Select Location'
                                onChange={e => setSelectedLocation(e)} />}
                            {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                        </div>}
                    </div>}
                    <CommonInputFloatFull
                        type='text'
                        id='notes'
                        onChange={e => setNotes(e.target.value)}
                        placeholder='Notes'
                        value={notes}
                        multiline={true}
                        rows={4}
                    />
                    <ButtonRow>
                        <CommonButton label='Submit'
                            onClick={() => { handleSubmitClick() }}
                        />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowSuccessModal(false) }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{addAssetSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to add another asset?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleAddNewAssetClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddAssets